export const IframeContent = () => (
    <iframe
        width="100%"
        height="500"
        src="https://www.youtube.com/embed/d91u-gsIRB4?si=TI1YaPV8k4qS-qV8"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
    />
);

export const IframeHelpContent = () => (
    <iframe
        width="100%"
        height="500"
        src="https://www.youtube.com/embed/qJOkZdnbA2A?si=8C86m-LI6npfYyD-"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
    />
);
